import React,{useEffect} from 'react';
import {btnSetColor_CBack,TableDatePicker} from '../../function_lib/common_lib';
import {Custom_Alert,Alert_Content} from '../../components/custom_alert';
export function Comp_Add_Steering_Record(props){
    const saveSteeringRec=()=>{
        btnSetColor_CBack(this,"frmAddSteeringRecord","addSteeringRecord",function(data,msg){
            Custom_Alert("View",msg,false);
        })
      }

  //alert(JSON.stringify(props.editUser));
   useEffect(()=>{

   },[props.editUser]);
  
    return(<div className="modal fade bd-example-modal-xl"  id="divAddSteeringRec" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div className="modal-dialog modal-xl" role="document">
      <div className="modal-content">
      <div className="modal-header bg-primary">
          <h5 className="modal-title text-white" id="exampleModalLabel">Steering Record </h5>
          <button type="button" className="close text-white" data-bs-dismiss="modal" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true" className="text-white">&times;</span>
          </button>
        </div>
        <form id="frmAddSteeringRecord" name="frmAddSteeringRecord">
        <input type="hidden" id="m_type" name="m_type" value={"addSteeringRecord"}/>
            <input type="hidden" id="res_func" name="res_func" value={"useit"}/>
            <input type="hidden" id="global_token" name="global_token" value={props.logUser[0]["app_user_id"]}/>
            <input type="hidden" id="local_token" name="local_token" value={props.logUser[0]["id"]}/>
            
        <div className="modal-body">
             {/* form content  */}
             <div class="container record-of-steeeringg text-start">
    <h2 class="text-center mb-4">Record of Steering Form</h2>
    
        <div class="row">
            <div class="col-md-6 form-group">
                <label><strong>Steering:</strong></label>
               <select id="steering" name="steering" class="form-select required" aria-label="Default select example">
                <option value={"0"}>Options</option>
                <option value="By compass (day)">By compass(day)</option>
                <option value="By compass (night)">By compass(night)</option>
                <option value="By sight (without aid of compass)">By sight (without aid of compass)</option>
                <option value="While entering and leaving port">While entering and leaving port</option>
                </select>
            </div>
            <div class="col-md-6 form-group">
                <label><strong>Voyage From:</strong></label>
                <input id="voyage_from" name="voyage_from" type="time" class="form-control required" required/>
            </div>
        </div>
        
        <div class="row">
            <div class="col-md-6 form-group">
                <label><strong>Voyage To:</strong></label>
                <input id="voyage_to" name="voyage_to" type="time" class="form-control required" required/>
            </div>
            
            <div class="col-md-6 form-group">
                <label><strong>Streered date:</strong></label>
                <div className="input-group input-group-sm">
                <TableDatePicker refName="steered_date" />
                </div>
                {/* <input name="steered_date" id="steered_date" type="text" class="form-control required" required/> */}
            </div>
        </div>

         <div class="row">
            <div class="col-md-6 form-group">
                <label><strong>Steered Duration From:</strong></label>
                <input name="steered_from" id="steered_from" type="time" class="form-control required" required/>
            </div>
             <div class="col-md-6 form-group">
                <label><strong>Steered Duration To:</strong></label>
                <input name="steered_to" id="steered_to" type="time" class="form-control required" required/>
            </div>
        </div>

        <div class="row">
            <div class="col-md-6 form-group">
                <label><strong>Total Hours:</strong></label>
                <input name="total_hrs" id="total_hrs" type="number" class="form-control require" required/>
            </div>
          
        </div>
       <div class="row">
        <div class="col-md-6 form-group">
                <label><strong>Remarks:</strong></label>
                <textarea id="remarks" name="remarks" class="form-control required">

                </textarea>
                {/* <input name="remarks" type="text" class="form-control" placeholder="Enter remarks" required/> */}
            </div>
            {/* <div class="col-md-6 form-group">
                <label><strong>OOW Signature</strong></label>
                <input name="ow_signature" type="text" class="form-control" required/>
            </div> */}
       </div>

      
    
</div>
             {/* end of form contacnt */}
        </div>
        <div className="modal-footer">
        <div id="getReponse" style={{color:"red"}}></div>
          <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" data-dismiss="modal">Close</button>
          <button type="button" onClick={()=>saveSteeringRec()} className="btn btn-primary">Save</button>
        </div>
        </form>
      </div>
      </div>
      </div>)
}

export default Comp_Add_Steering_Record;